import { getRequest } from '@/core';
import { edi } from '@/requests';

export default async function(transmissionId) {
	let url = edi.inspectInboundTransmission(transmissionId);

	let result = await getRequest(url);
	return result;
}